import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DepartmentLevel } from "models/department-level";

export interface AdminDepartmentLevelsSliceState {
    departmentLevels: DepartmentLevel[];
    editingDepartmentLevel: DepartmentLevel | null;
}

export const initialState: AdminDepartmentLevelsSliceState = {
    departmentLevels: [],
    editingDepartmentLevel: null,
};

const AdminDepartmentLevelsSlice = createSlice({
    name: "admin-department-levels-slice",
    initialState,
    reducers: {
        setDepartmentLevels(state, { payload }: PayloadAction<DepartmentLevel[]>) {
            state.departmentLevels = payload;
        },
        addDepartmentLevel(state, { payload }: PayloadAction<DepartmentLevel>) {
            state.departmentLevels = [payload, ...state.departmentLevels];
        },
        setDepartmentLevel(state, { payload }: PayloadAction<DepartmentLevel>) {
            const index = state.departmentLevels.findIndex(d => d.id === payload.id);
            if (index !== -1) {
                state.departmentLevels[index] = payload;
            }
        },
        removeDepartmentLevel(state, { payload: departmentLevelId }: PayloadAction<string>) {
            state.departmentLevels = state.departmentLevels.filter(d => d.id !== departmentLevelId);
        },
        setEditingDepartmentLevel(state, { payload }: PayloadAction<DepartmentLevel | null>) {
            state.editingDepartmentLevel = payload;
        },
    },
});

export const {
    setDepartmentLevels,
    addDepartmentLevel,
    setDepartmentLevel,
    removeDepartmentLevel,
    setEditingDepartmentLevel,
} = AdminDepartmentLevelsSlice.actions;

export default AdminDepartmentLevelsSlice.reducer;
